import Link from "next/link";
import { PropsWithChildren } from "react";
import { ArrowDirection } from "./link";

export interface IButtonProps {
	readonly title?: string;
	readonly arrow?: ArrowDirection;
	onClick: { (): void };
}

export interface ILinkButtonProps {
	readonly href: string;
	readonly title?: string;
	readonly arrow?: ArrowDirection;
	readonly overwriteButtonColor?: string;
}

export interface ISubmitButtonProps {
	readonly title?: string;
	readonly arrow?: ArrowDirection;
}

export const FormattedButton: React.FC<PropsWithChildren<IButtonProps>> = ({
	title,
	children,
	arrow = ArrowDirection.right,
	onClick,
}) => {
	return (
		<button
			onClick={onClick}
			title={title}
			className={`block font-title font-semibold text-black hover:text-white focus-within:text-white bg-white hover:bg-epic-light-red focus-within:bg-epic-light-red transition-all duration-300 ease-in-out px-4 py-2 border border-epic-light-brown`}
		>
			{arrow === ArrowDirection.left ? "\u2190\u00A0" : ""}
			{children}
			{arrow === ArrowDirection.right ? "\u00A0\u2192" : ""}
		</button>
	);
};

export const FormattedLinkButton: React.FC<PropsWithChildren<ILinkButtonProps>> = ({
	href,
	title,
	children,
	arrow = ArrowDirection.right,
	overwriteButtonColor = "",
}) => {
	return (
		<Link
			href={href}
			id={`formatted_link_button_${href}`}
			title={title}
			passHref
			tabIndex={-1}
			className={
				overwriteButtonColor !== ""
					? `block font-title font-semibold text-white ` +
						overwriteButtonColor +
						` px-4 py-2 border border-epic-light-brown`
					: `block font-title font-semibold text-black hover:text-white focus-within:text-white bg-white hover:bg-epic-light-red focus-within:bg-epic-light-red transition-all duration-300 ease-in-out px-4 py-2 border border-epic-light-brown`
			}
		>
			<button>
				{arrow === ArrowDirection.left ? "\u2190\u00A0" : ""}
				{children}
				{arrow === ArrowDirection.right ? "\u00A0\u2192" : ""}
			</button>
		</Link>
	);
};

export const FormattedSubmitButton: React.FC<PropsWithChildren<ISubmitButtonProps>> = ({
	title,
	children,
	arrow = ArrowDirection.right,
}) => {
	return (
		<button
			type="submit"
			title={title}
			className={`block font-title font-semibold text-black hover:text-white focus-within:text-white bg-white hover:bg-epic-light-red focus-within:bg-epic-light-red transition-all duration-300 ease-in-out px-4 py-2 border border-epic-light-brown`}
		>
			{arrow === ArrowDirection.left ? "\u2190\u00A0" : ""}
			{children}
			{arrow === ArrowDirection.right ? "\u00A0\u2192" : ""}
		</button>
	);
};
